module.exports = __webpack_public_path__ + "assets/img/pitch.png?17008b99084224e8ba5d5b3ef04bd71d";